'use client';

import { FileText, LogIn } from 'lucide-react';
import Link from 'next/link';
import { useActionState } from 'react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { login } from './actions';
import { useToast } from '@/hooks/use-toast';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const [state, formAction] = useActionState(login, null);
  const { toast } = useToast();
  const router = useRouter();

  // Check if user is already logged in
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch('/api/auth/session');
        const { isLoggedIn } = await response.json();
        
        if (isLoggedIn) {
          router.push('/');
        }
      } catch (error) {
        // If session check fails, stay on login page
        console.log("Session check failed, staying on login page");
      }
    };

    checkSession();
  }, [router]);

  useEffect(() => {
    if (state?.error) {
      toast({
        variant: 'destructive',
        title: 'Login Failed',
        description: state.error,
      });
    }
  }, [state, toast]);


  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-4">
      <Card className="mx-auto max-w-sm w-full shadow-lg">
        <CardHeader className="space-y-4 text-center">
          <div className="inline-block bg-primary text-primary-foreground p-4 rounded-full mx-auto">
            <FileText className="h-8 w-8" />
          </div>
          <CardTitle className="text-3xl font-bold text-primary">TDRI Member</CardTitle>
          <CardDescription>Enter your credentials to access your documents</CardDescription>
        </CardHeader>
        <CardContent>
          <form action={formAction} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" placeholder="m@example.com" required />
            </div>
            <div className="space-y-2">
               <Label htmlFor="password">Password</Label>
              <Input id="password" name="password" type="password" required />
            </div>
            <Button type="submit" className="w-full bg-accent hover:bg-accent/90">
              <LogIn className="mr-2 h-4 w-4" />
              Login
            </Button>
          </form>
          <div className="mt-4 text-center text-sm text-muted-foreground">
            Contact your administrator if you have trouble logging in.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
